import React from 'react';
import './header.css';

export default class Header extends React.Component {
	render(){
		return(
			<div className="header">
				<img 
					alt="logo do site, uma mistura da imagem do atomo com controle de video game" 
					src="/img/logo.png" 
					className="logo" />
				<h1 className="titulo-header">React Games BR</h1>
				<span className="slogan-header">1 Novo App por Semana</span>
			</div>	
		);
	}
}


// WEBPACK FOOTER //
// ./src/header.js